import { recentWishListsStyles as styles } from "@solveindustrial/Overrides/Widgets/Common/RecentWishLists";
import {
    cardContainerCommonStyles,
    cardNoItemsCommonStyles,
    cardSummaryCommonStyles,
} from "@solveindustrial/WidgetExtensions/Common/RecentOrdersExtension";
import { css } from "styled-components";

styles.cardContainer = {
    ...styles.cardContainer,
    cardDivider: {
        css: css`
            ${styles.cardContainer?.cardDivider?.css};
            ${cardContainerCommonStyles}
        `,
    },
};

styles.wishListCardGridItem = {
    ...styles.wishListCardGridItem,
    css: css`
        ${styles.wishListCardGridItem?.css};
        ${cardSummaryCommonStyles}
    `,
};

styles.wishListCard = {
    ...styles.wishListCard,
    gridContainer: {
        ...styles.wishListCard?.gridContainer,
        offsetCss: css`
            ${styles.wishListCard?.gridContainer?.offsetCss};
            ${cardSummaryCommonStyles}
        `,
    },
};

styles.noWishListsFoundGridItem = {
    ...styles.noWishListsFoundGridItem,
    css: css`
        ${styles.noWishListsFoundGridItem?.css};
        ${cardNoItemsCommonStyles}
    `,
};
